import './ActivePlansCardSkeleton.scss';

const SKELETON_ROWS = 2;

const ActivePlansCardSkeleton = () => (
  <div className="active-plans-card-skeleton" aria-hidden="true">
    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
      <div key={index} className="active-plans-card-skeleton__row">
        <div className="active-plans-card-skeleton__head">
          <span className="active-plans-card-skeleton__bar active-plans-card-skeleton__bar--name" />
          <span className="active-plans-card-skeleton__bar active-plans-card-skeleton__bar--badge" />
        </div>
        <span className="active-plans-card-skeleton__bar active-plans-card-skeleton__bar--summary" />
      </div>
    ))}
  </div>
);

export default ActivePlansCardSkeleton;
